<template>
    <div class="curriculum-lesson-detail">
        <el-dialog title="修改科任老师" :visible.sync="isCheckedLessonDetailDialogShow" width="30%"
            :before-close="lessonDetailDialogClose" @open="dialogOpen">
            <div class="lesson-detail-container">
                <div class="lesson-detail-content">
                    <div class="content-item">
                        <div class="item-label">
                            科目：
                        </div>
                        <span class="item-value">
                            {{ detail.courseName }}
                        </span>
                    </div>
                    <div class="content-item">
                        <div class="item-label">
                            课室：
                        </div>
                        <span class="item-value">
                            {{ detail.classroomName }}
                        </span>
                    </div>
                    <div class="content-item">
                        <div class="item-label">
                            科任老师：
                        </div>
                        <!-- <span class="item-value">
                            {{ detail.teacherName }}
                        </span> -->
                        <el-select class="item-value select-teacher" v-model="detail.teacherName" filterable
                            placeholder="请选择科任老师" @change="teacherChange"
                            :disabled="!userPermissions.includes('sc:coursearrange:edit')">
                            <el-option v-for="teacherItem in teacherList" :key="teacherItem.teacherId"
                                :label="teacherItem.teacherName" :value="teacherItem.index">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <!-- <el-button @click="lessonDetailDialogClose()">取 消</el-button> -->
                <el-button type="primary" @click="confirm" v-hasPermi="'sc:coursearrange:edit'">保 存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        lessonDetail: {
            type: Object,
        },
        isCheckedLessonDetailDialogShow: {
            type: Boolean,
        },
        classId: {
            type: [String, Number],
        }
    },
    data() {
        return {
            teacherList: [],
            detail: {},
            userPermissions: [], // 权限列表
        };
    },
    created() {
        // console.log("this.lessonDetail:", this.lessonDetail);
        this.detail = JSON.parse(JSON.stringify(this.lessonDetail));
        this.userPermissions = window.localStorage.getItem("menuPermissions");
        this.getTeacherList();
    },
    methods: {
        teacherChange(e) {
            this.detail.name = this.teacherList[e].teacherName;
            this.detail.teacherId = this.teacherList[e].teacherId;
            this.detail.teacherNumber = this.teacherList[e].teacherNumber;
        },
        dialogOpen() {
            this.detail = JSON.parse(JSON.stringify(this.lessonDetail));
        },
        confirm() {
            let { courseId, teacherId, teacherNumber, name } = this.detail;
            let data = {
                classId: this.classId,
                courseId,
                teacherId,
                teacherNumber,
                teacherName: name,
            };
            this.$emit("editCourseTeacherConfirm", data);
        },
        lessonDetailDialogClose() {
            this.$emit('lessonDetailDialogClose')
        },
        getTeacherList() {
            this.post(this.$url.selectTeacherListByClassIdPC, {
                classId: this.classId,
            })
                .then((res) => {
                    // console.log("第二步获取教师列表==>", res);
                    if (res.code != 200) {
                        return this.$message.error("获取教师列表失败！");
                    }
                    const teacherList = res.data;
                    teacherList.forEach((item, index) => {
                        this.teacherList.push({
                            teacherId: item.teacherId,
                            teacherName: item.teacherName,
                            teacherNumber: item.teacherNumber,
                            index,
                        });
                    });
                    // console.log("teacherList:", this.teacherList);
                })
                .catch((err) => {
                    return this.$message.error("获取教师列表失败！");
                });
        },
    }
};
</script>

<style scoped lang="scss">
@import "./curriculumLessonDetail.scss";
</style>